module.exports = __webpack_public_path__ + "static/img/h_item1.13d3382e.png";